import urlParamsSlice from "../slices/urlParamsSlice";

export const urlParamsReducers = {
  urlParams: urlParamsSlice,
};
